/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import _ from 'lodash'
import { Component } from 'react'
import { Container } from 'flux/utils'
import { withRouter } from 'react-router'
import AutoActionTaskView from '../../view/pages/auto_action/AutoActionTaskView'
import AutoActionTasksStore from '../../store/auto_action/AutoActionTasksStore'
import AutoActionTaskStore from '../../store/auto_action/AutoActionTaskStore'
import RoomOptionsStore from '../../store/options/RoomOptionsStore'
import SiteReferrerOptionsStore from '../../store/options/SiteReferrerOptionsStore'
import AutoTaskActions from '../../action/auto_action/AutoTaskActions'

class AutoActionTaskContainer extends Component {
  static getStores() {
    return [AutoActionTasksStore, AutoActionTaskStore, RoomOptionsStore, SiteReferrerOptionsStore]
  }

  static calculateState(prevState, props) {
    return {
      tasks: AutoActionTasksStore.getState(),
      task: AutoActionTaskStore.getState(),
      room_options: RoomOptionsStore.getState(),
      site_referrer_options: SiteReferrerOptionsStore.getState(),
      ...props
    }
  }

  componentDidMount() {
    AutoTaskActions.fetchAll()

    const showEdit = _.propertyOf(this.state)('showEdit') || false
    if (showEdit) {
      AutoTaskActions.fetchRooms()
      AutoTaskActions.fetchSiteReferrers('auto_action')
      if (this.state.match.params.id) {
        AutoTaskActions.fetchOne(this.state.match.params.id)
      }
    }
  }

  render() {
    return AutoActionTaskView(this.state)
  }
}

export default withRouter(Container.create(AutoActionTaskContainer, { withProps: true }))
